// Force the browser onto freshly-deployed frontend assets.
//
// Appends a unique `_cb` param so the *navigation itself* misses the HTTP
// disk cache and the HTML document is re-fetched from the server. Django then
// renders the page with the new `?v=<hash>` bundle URLs (versioned_static), so
// the browser pulls the updated JS/CSS. This is the same effect a user gets
// from Ctrl+Shift+R, achievable from page JS.
//
// Deliberately does NOT clear Cache Storage or unregister the service worker:
// sw.js is push-only with a no-op fetch handler (it caches no assets), and
// tearing it down would drop the user's Web Push subscription for no benefit.
export default function cacheBustReload() {
  const url = new URL(window.location.href);
  url.searchParams.set('_cb', Date.now());
  window.location.replace(url.toString());
}
